import MHeadline from './MHeadline.vue';

export { MHeadline };
export default MHeadline;
